import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  list: {
    padding: 0,
    listStyleType: 'none',

    '& li': {
      display: 'flex',

      '&:nth-child(n+2)': {
        marginTop: 16,
      },
    },
  },
  icon: {
    height: 24,
    width: 24,
    marginRight: 16,
  },
}));

export default useStyles;
